import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.async-iterator.for-each.js";
import "core-js/modules/esnext.iterator.for-each.js";
import _defineProperty from "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.27.4_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_7cca35337dd8404c2bdaa7eb9a6410df/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.27.4_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_7cca35337dd8404c2bdaa7eb9a6410df/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.27.4_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_7cca35337dd8404c2bdaa7eb9a6410df/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["anchorProps", "children", "className", "hash", "isAnchor", "onClick", "onNavigate", "pathname", "query", "style", "target", "title"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useSyncedRef } from "@react-hookz/web";
import pick from "lodash/pick";
import Link from "next/link";
import { useRouter } from "next/router";
import qs from "qs";
import React, { forwardRef, useEffect } from "react";
import { tracking } from "shared/data";
import { isEnabledClientRoute } from "shared/lib/utils";
import { useBaseLinkContext } from "./context";
import { StyledAnchor } from "./styles";

// ExternalQuery is query string used externally and should shown in the href
// Example Usage: GTM variables: `Query String - House Ad`

// InternalQuery is query string used internally and should not be shown in the href

const externalQueryTypeTemplate = {
  campaign: "",
  display: "",
  dl_hash: "",
  label: "",
  module: tracking.module.Inline,
  origin: "",
  pgtype: tracking.pageType.Article,
  utm_source: ""
};
const validExternalQueryKeys = Object.keys(externalQueryTypeTemplate);
export const BaseLink = /*#__PURE__*/forwardRef((_ref, reference) => {
  let {
      anchorProps,
      children,
      className,
      hash,
      isAnchor,
      onClick,
      onNavigate,
      pathname,
      query,
      style,
      target,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    customQueryParameters
  } = useBaseLinkContext();
  const customizedTarget = target ?? (anchorProps === null || anchorProps === void 0 ? void 0 : anchorProps.target) ?? "";
  const renderAnchor = href => __jsx(StyledAnchor, _extends({}, anchorProps, {
    className: className,
    href: href,
    onClick: onClick,
    ref: reference,
    style: style,
    target: customizedTarget,
    title: title,
    "data-qa": "BaseLink-renderAnchor-StyledAnchor"
  }), children);
  const mergedQuery = _objectSpread(_objectSpread({}, customQueryParameters), query);

  // Need to keep the external query string in the display url for GTM to pick up the values
  const externalQueryString = qs.stringify(pick(mergedQuery, validExternalQueryKeys), {
    addQueryPrefix: true
  });
  const asUrl = `${props.as ?? pathname}${externalQueryString}${hash ?? ""}`;
  const {
    events
  } = useRouter();
  const latestOnNavigate = useSyncedRef(onNavigate);
  useEffect(() => {
    const onRouteChangeComplete = () => {
      var _latestOnNavigate$cur;
      latestOnNavigate === null || latestOnNavigate === void 0 || (_latestOnNavigate$cur = latestOnNavigate.current) === null || _latestOnNavigate$cur === void 0 || _latestOnNavigate$cur.call(latestOnNavigate);
    };
    events.on("routeChangeComplete", onRouteChangeComplete);
    return () => {
      events.off("routeChangeComplete", onRouteChangeComplete);
    };
  }, [events, latestOnNavigate]);
  if (!isEnabledClientRoute(pathname) || isAnchor) {
    return renderAnchor(asUrl);
  }
  return __jsx(Link, _extends({
    title: title
  }, props, anchorProps, {
    as: asUrl,
    className: className,
    href: {
      hash,
      pathname,
      query: mergedQuery
    },
    onClick: onClick,
    passHref: true,
    ref: reference,
    style: style,
    "data-qa": "BaseLink-Link"
  }), children);
});
BaseLink.displayName = "BaseLink";